import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Accordion, Button, Card, Container, Form, FormControl, FormLabel, Image, Modal, Tab, Tabs } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "../general.css";
import "./winner.css";
import pass from "./password.json";
import { useCookies } from "react-cookie";

const Winner = ({ en }) => {
    const [show, setShow] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies();

    if (cookies.allClear) {
        return (
            <>
                <div className='winner_button' style={{ backgroundImage: "url('/img/win.png')" }} onClick={() => setShow(true)}></div>
                <Modal show={show} size='lg' onHide={() => setShow(false)} centered className='text-dark'>
                    <Modal.Header closeButton>
                        {en ? "Perfect Certificate" : "パーフェクト証明書"}
                    </Modal.Header>
                    <Modal.Body className='m-4'>
                        {en ? "Let's show this certificate to the receptionist!" : "この証明書を受付の人に見せよう！"}
                        <hr />
                        <Tabs
                            defaultActiveKey="Arabic"
                            id="certificate_goods"
                            className="mb-3"
                            fill
                        >
                            <Tab eventKey="Arabic" title={en ? "Arabic" : "アラビア語"}>
                                <Image src='/img/clear_ab.png' width="100%" />
                            </Tab>
                            <Tab eventKey="Japanese" title={en ? "Japanese" : "日本語"}>
                                <Image src='/img/clear_ja.png' width="100%" />
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                </Modal>
            </>
        )
    } else {
        return (
            <></>
        )
    }
}

export default Winner;
